import { invariant } from "@olenbetong/appframe-core";

export type LoginOptions = {
	remember?: boolean;
};

export interface IClient {
	readonly hostname: string;

	/**
	 * Wraps fetch and adds JSON headers (Accept and Content-Type) and X-Requested-With
	 * which is required by some handlers. If timeout is set in `init`, the request will
	 * be aborted if not finished by the amount of milliseconds set.
	 *
	 * If Content-Type should not be JSON, either pass in another Content-Type, or set
	 * isJson to false in `init`
	 */
	afFetch(url: string, init: RequestInit & { timeout?: number; isJson?: boolean }): Promise<Response>;
	fetch(input: any, init: any): Promise<Response>;
	login(username: string, password: string, options?: LoginOptions): Promise<boolean>;
	setHostname(hostname?: string): void;
}

let defaultClient: IClient;

export function getDefaultClient() {
	invariant(defaultClient, "No default client has been set");
	return defaultClient;
}

export function setDefaultClient(client: IClient) {
	defaultClient = client;
}
